import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4071fc6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cookie-bar shadow-lg border-top border-primary"
}
const _hoisted_2 = { class: "container-fluid py-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "accent-3 text-center mb-4 display-6" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-auto mx-auto" }
const _hoisted_8 = { class: "d-flex justify-content-center" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "d-flex justify-content-center" }
const _hoisted_13 = { class: "list-group mt-2" }
const _hoisted_14 = { class: "list-group" }
const _hoisted_15 = { class: "form-check form-switch" }
const _hoisted_16 = ["id", "checked", "onChange", "disabled"]
const _hoisted_17 = ["for"]
const _hoisted_18 = { class: "col-12 text-center mt-3" }

import { ref, onMounted } from 'vue';

    interface Cookie {
        id: string;
        name: string;
        category: string;
        accepted: boolean;
        disabled: boolean;
    }

    interface CookieCategory {
        id: string;
        name: string;
        cookies: Cookie[];
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CookieBar',
  setup(__props) {

    const cookieCategories: CookieCategory[] = [
        {
            id: 'necessary',
            name: 'Nödvändiga',
            cookies: [
                {
                    id: 'necessary-site-cookie',
                    name: 'Lagrar dina val av cookies',
                    category: 'necessary',
                    accepted: true,
                    disabled: true
                },
            ],
        },
        //{
        //    id: 'marketing',
        //    name: 'Marknadsföring',
        //    cookies: [
        //        {
        //            id: 'cookie3',
        //            name: 'Marknadsföringscookie 1',
        //            category: 'marketing',
        //            accepted: true,
        //        },
        //        {
        //            id: 'cookie4',
        //            name: 'Marknadsföringscookie 2',
        //            category: 'marketing',
        //            accepted: true,
        //        },
        //    ],
        //},
        {
            id: 'statisical',
            name: 'Statistik- och analyskakor',
            cookies: [
                {
                    id: 'ga4',
                    name: 'Google Analytics 4 - För att analysera hur besökare använder webbplatsen och för att optimera innehållet för att passa dina behov',
                    category: 'statisical',
                    accepted: true,
                    disabled: false
                }
            ]
        }
    ];

    const cookieMessage = ref('Vi använder cookies 🍪 för att förbättra din upplevelse på webbplatsen!');
    const acceptAllButtonText = ref('ACCEPTERA');
    const declineAllButtonText = ref('AVVISA');
    const selectCookiesText = ref('VÄLJ SJÄLV');

    const showCookieBar = ref(false);
    const showCookies = ref(false);

    const toggleCookie = (cookie: Cookie): void => {
        cookie.accepted = !cookie.accepted;
    };

    const acceptCookies = (): void => {
        showCookieBar.value = false;

        const selectedCookies = cookieCategories.flatMap((category) =>
            category.cookies.filter((cookie) => cookie.accepted).map((cookie) => cookie.id));

        localStorage.setItem('selectedCookies', JSON.stringify(selectedCookies));

        runCookies(selectedCookies);
    };

    const acceptAllCookies = (): void => {
        for (const category of cookieCategories) {
            for (const cookie of category.cookies.filter(x => !x.disabled)) {
                cookie.accepted = true;
            }
        }

        acceptCookies();
    };

    const declineAllCookies = (): void => {
        for (const category of cookieCategories) {
            for (const cookie of category.cookies.filter(x => !x.disabled)) {
                cookie.accepted = false;
            }
        }

        acceptCookies();
    };

    const selectCookies = (): void => {
        showCookies.value = true;
    };

    const runCookies = (ids: string[]): void => {
        for (const id of ids) {
            switch (id) {
                case 'ga4':
                    initGoogleAnalytics();
                    break;
            }
        }
    };

    const initGoogleAnalytics = (): void => {
        const isProduction = process.env.NODE_ENV === 'production';
        if (!isProduction)
            return;

        const script = document.createElement('script');
        script.src = 'https://www.googletagmanager.com/gtag/js?id=G-426SG6KY3G';
        script.async = true;
        script.onload = () => {
            (window as any).dataLayer = (window as any).dataLayer || [];
            function gtag() { (window as any).dataLayer.push(arguments); }
            gtag('js', new Date());

            gtag('config', 'G-426SG6KY3G');
        };

        const head = document.querySelector('head');
        if (head)
            head.appendChild(script);
    };

    onMounted(() => {
        const storedCookies: string[] | null = localStorage.getItem('selectedCookies')
            ? JSON.parse(localStorage.getItem('selectedCookies') ?? '')
            : null;

        if (storedCookies === null) {
            showCookieBar.value = true;
            return;
        }

        runCookies(storedCookies);
    });

return (_ctx: any,_cache: any) => {
  return (showCookieBar.value)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h6", _hoisted_5, _toDisplayString(cookieMessage.value), 1)
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  onClick: acceptAllCookies,
                  class: "btn btn-primary me-2 btn-custom-size d-none d-md-block"
                }, _toDisplayString(acceptAllButtonText.value), 1),
                _createElementVNode("button", {
                  onClick: declineAllCookies,
                  class: "btn btn-secondary me-4 btn-custom-size d-none d-md-block"
                }, _toDisplayString(declineAllButtonText.value), 1),
                _createElementVNode("button", {
                  onClick: selectCookies,
                  class: "btn btn-outline-primary text-white btn-select-cookies btn-custom-size d-none d-md-block"
                }, _toDisplayString(selectCookiesText.value), 1),
                _createElementVNode("button", {
                  onClick: acceptAllCookies,
                  class: "btn btn-primary me-2 d-md-none"
                }, _toDisplayString(acceptAllButtonText.value), 1),
                _createElementVNode("button", {
                  onClick: declineAllCookies,
                  class: "btn btn-secondary me-4 d-md-none"
                }, _toDisplayString(declineAllButtonText.value), 1),
                _createElementVNode("button", {
                  onClick: selectCookies,
                  class: "btn btn-outline-primary text-white btn-select-cookies d-md-none"
                }, _toDisplayString(selectCookiesText.value), 1)
              ])
            ])
          ], 512), [
            [_vShow, !showCookies.value]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("ul", _hoisted_13, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cookieCategories, (category) => {
                      return _createElementVNode("li", {
                        key: category.id,
                        class: "list-group-item",
                        style: {"background-color":"#ececec"}
                      }, [
                        _createElementVNode("h5", null, _toDisplayString(category.name), 1),
                        _createElementVNode("ul", _hoisted_14, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.cookies, (cookie) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: cookie.id,
                              class: "list-group-item bg-white"
                            }, [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  id: cookie.id,
                                  checked: cookie.accepted,
                                  onChange: ($event: any) => (toggleCookie(cookie)),
                                  class: "form-check-input border-secondary",
                                  disabled: cookie.disabled
                                }, null, 40, _hoisted_16),
                                _createElementVNode("label", {
                                  for: cookie.id,
                                  class: "form-check-label"
                                }, _toDisplayString(cookie.name), 9, _hoisted_17)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    }), 64))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  onClick: acceptCookies,
                  class: "btn btn-primary btn-custom-size me-2"
                }, _toDisplayString(acceptAllButtonText.value), 1),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showCookies.value = false)),
                  class: "btn btn-secondary btn-custom-size"
                }, "AVBRYT")
              ])
            ])
          ], 512), [
            [_vShow, showCookies.value]
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})